<div *ngIf="isPermissionLoaded" class="container">
  <h1 class="page-title">
    <span class="icon">
      <i class="fi fi-ss-search-alt"></i>
      {{ "ManualAllocation.WMS.Header" | translate }}
    </span>
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="field col-4">
              <label>{{ "ManualAllocation.Search.DoNo" | translate }}</label>
              <input
                pInputText
                type="text"
                formControlName="externOrderKey"
                [disabled]="true"
              />
            </div>

            <div class="field col-4">
              <label>{{
                "ManualAllocation.DetailColumn.OrderLineNo" | translate
              }}</label>
              <input
                pInputText
                type="text"
                formControlName="orderLineNo"
                [disabled]="true"
              />
            </div>

            <div class="field col-4">
              <label>{{ "ManualAllocation.WMS.Search.SKU" | translate }}</label>
              <input
                pInputText
                type="text"
                formControlName="sku"
                [disabled]="true"
              />
            </div>

            <div class="field col-4">
              <label>{{
                "ManualAllocation.WMS.Search.CaseId" | translate
              }}</label>
              <input pInputText type="text" formControlName="caseId" />
            </div>

            <div class="field col-4">
              <label>{{ "ManualAllocation.WMS.Search.UId" | translate }}</label>
              <input pInputText type="text" formControlName="uId" />
            </div>

            <div class="field col-4">
              <label>{{
                "ManualAllocation.WMS.Search.DateCode" | translate
              }}</label>
              <input pInputText type="text" formControlName="dateCode" />
            </div>

            <div class="field col-4">
              <label>{{
                "ManualAllocation.WMS.Search.VendorLot" | translate
              }}</label>
              <input pInputText type="text" formControlName="vendorLot" />
            </div>
            <!-- ATTRIBUTE06=vendorId -->
            <div class="field col-4">
              <label>{{
                "ManualAllocation.WMS.Search.VendorId" | translate
              }}</label>
              <input pInputText type="text" formControlName="attribute06" />
            </div>

            <div class="field col-4">
              <label>{{ "ManualAllocation.WMS.Search.Loc" | translate }}</label>
              <input pInputText type="text" formControlName="loc" />
            </div>

            <div class="field col-4">
              <label>{{ "ManualAllocation.WMS.Search.LocId" | translate }}</label>
              <input pInputText type="text" formControlName="locId" />
            </div>

            <div class="field col-4">
              <label>{{
                "ManualAllocation.WMS.Search.SpecLocType" | translate
              }}</label>
              <input pInputText type="text" formControlName="specLotType" />
            </div>
          </div>

          <div>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Search' | translate }}"
              (click)="searchBtnClick()"
            ></button>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Reset' | translate }}"
              (click)="resetClickBtn($event)"
              class="p-button-secondary ml-2"
            ></button>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <p-tabView>
      <p-tabPanel
        header="{{ 'ManualAllocation.WMS.AllocatedTable' | translate }}"
      >
        <div class="mt-2">
          <laas-data-table
            #AllocatedTable
            [tableKey]="allocatedPreferenceKey"
            [defaultColumns]="allocatedTableColumns"
            [value]="allocatedResultTableValue"
            [loading]="isAllocatedTableLoading"
            dataKey="rowSeq"
            [selectable]="true"
            styleClass="p-datatable-gridlines p-datatable-striped mt-2 white-space: nowrap;"
          >
            <ng-template pTemplate="caption">
              <button
                (click)="deleteAllocatedBtnClick($event)"
                pButton
                class="p-button-info ml-2"
                label="{{
                  'ManualAllocation.WMS.Button.DeleteAllocation' | translate
                }}"
                [disabled]="isDeleteAllocationDisabled"
              ></button>
            </ng-template>

            <ng-template pTemplate="body" let-columns="columns" let-rowData>
              <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col.field">
                  <ng-container *ngSwitchDefault class="p-fluid">
                    <ng-container [ngSwitch]="col.dataType">
                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">
                          {{ rowData[col.field] | replaceNullWith : "-" }}
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </td>
            </ng-template>
          </laas-data-table>
        </div>
      </p-tabPanel>

      <p-tabPanel
        header="{{ 'ManualAllocation.WMS.AvailableAllocationTable' | translate }}"
      >
        <div class="mt-2">
          <laas-data-table
            #InventoryTable
            [tableKey]="availablePreferenceKey"
            [defaultColumns]="availableTableColumns"
            [value]="inventoryResultTableValue"
            [editPermission]="editPermissionCode"
            dataKey="rowSeq"
            [loading]="isLoading"
            [selectable]="true"
            [isShowCreateRowFunction]="false"
            [isShowSaveFunction]="false"
          >
            <ng-template pTemplate="caption">
              <button
                (click)="allocationBtnClick($event)"
                pButton
                class="p-button-info ml-2"
                label="{{ 'ManualAllocation.WMS.Button.Allocation' | translate }}"
              ></button>
              <ng-container
                *ngTemplateOutlet="InventoryTableTitle"
              ></ng-container>
            </ng-template>

            <ng-template pTemplate="body" let-columns="columns" let-rowData>
              <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col.field">
                  <ng-container *ngSwitchDefault class="p-fluid">
                    <ng-container [ngSwitch]="col.dataType">
                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">
                          {{ rowData[col.field] | replaceNullWith : "-" }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'date'">
                        <div class="overflow-text">
                          {{
                            rowData[col.field]
                              | date
                                : "yyyy-MM-dd HH:mm:ss"
                                : this.laasSetting.facilityTimeZone
                              | replaceNullWith : "-"
                          }}
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </td>
            </ng-template>

            <!--Input-->
            <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'qty'" class="p-fluid">
                  <input
                    type="number"
                    pInputText
                    [(ngModel)]="rowData[col.field]"
                    appendTo="body"
                    class="p-fluid"
                  />
                  <small
                    *ngIf="!checkNumberInteger(rowData[col.field])"
                    class="alert"
                  >
                    <div class="p-invalid">
                      {{
                        "ManualAllocation.WMS.Message.EnterInterger" | translate
                      }}
                    </div>
                  </small>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div [ngSwitch]="col.dataType" class="overflow-text">
                    <ng-container *ngSwitchCase="'date'" class="p-fluid">
                      {{
                        rowData[col.field]
                          | date : "yyyy-MM-dd HH:mm:ss"
                          | replaceNullWith : "-"
                      }}
                    </ng-container>
                    <ng-container *ngSwitchDefault class="p-fluid">
                      {{ rowData[col.field] | replaceNullWith : "-" }}
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </ng-template>

            <!--Output-->
            <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchDefault class="p-fluid">
                  <ng-container [ngSwitch]="col.dataType">
                    <ng-container *ngSwitchDefault>
                      <div class="overflow-text">
                        {{ rowData[col.field] | replaceNullWith : "-" }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'date'">
                      <div class="overflow-text">
                        {{
                          rowData[col.field]
                            | date
                              : "yyyy-MM-dd HH:mm:ss"
                              : this.laasSetting.facilityTimeZone
                            | replaceNullWith : "-"
                        }}
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-template>
          </laas-data-table>
        </div>
      </p-tabPanel>
    </p-tabView>

    <ng-template #AllocatedTableTitle>
      <div class="col-6 font-bold">
        {{ "ManualAllocation.WMS.AllocatedTable" | translate }}
      </div>
    </ng-template>

    <ng-template #InventoryTableTitle>
      <div class="col-6 font-bold">
        {{ "ManualAllocation.WMS.AvailableAllocationTable" | translate }}
      </div>
    </ng-template>
  </p-card>
</div>
